// Error message constants used across the application
export const ERROR_MESSAGES = {
  USER_ALREADY_EXISTS: 'Cannot create user that already exists',
  USER_DISABLED: 'User Already exists and it is disabled'
} as const;
